import React from 'react';
import '../../Default.css';
import './Twisters.css'
import type Twister from './twistersType'
import twistersData from "./twisters.json"
const twisters: Twister[] = twistersData as any;


function Twisters() {
    return (
      <>
        <div className="page-title">
          Tongue twisters
        </div>
        <div className='boxes-contener'>
          {twisters.map((twister, index) => 
            <div className='text-box' key={index}>
              {twister.image &&
                <img className='twister-img' src={twister.image} alt="obraz" />
              }
              
              {twister.author
                ? 
                  <div>
                    <div className='paragraf cite'>{twister.text}</div>
                    <div className='paragraf cite-author'>~ {twister.author}</div>
                  </div>
                : 
                  <div className='paragraf'>{twister.text}</div>
              }              
            </div>
          )}
        </div>
      </>
    );
}

export default Twisters;
